

import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { DxReportViewerComponent, DxReportViewerModule } from 'devexpress-reporting-angular';
import { environment } from 'src/environments/environment';
import { PreviewElements } from 'devexpress-reporting/dx-webdocumentviewer'
import { ActionId } from 'devexpress-reporting/dx-webdocumentviewer'
import { Inject } from '@angular/core';

//import { } from '@devexpress/analytics-core/dx-analytics-core'
@Component({
  selector: 'app-root',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    DxReportViewerModule
  ],

  templateUrl: './home.component.html',
  styleUrls: [
    "../../../../node_modules/devextreme/dist/css/dx.light.css",
    "../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css",
    "../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css",
    "../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css"
  ]
})
export class HomeComponent {
  @ViewChild(DxReportViewerComponent, { static: false })
  viewer: DxReportViewerComponent;


  title = 'DXReportViewerSample';
  reportId: number;
  fromvno: string;
  tovno: string;
  noOfCopy: number = 1;
  source: string;
  //   invokeAction = "/ReportDesigner/GetReportDesignerModel";
  //    reportUrl = "Products";
  //  hostUrl = 'http://localhost:54111/';

  // reportUrl: string = 'TestCompany';
  // hostUrl: string = 'https://localhost:7016/';
  // Use this line if you use an ASP.NET MVC backend
  //invokeAction: string = "/WebDocumentViewer/Invoke";
  //Use this line if you use an ASP.NET Core backend
  // invokeAction: string = '/CustomReportDesigner/GetReportDesignerModel1';
  BUID: string;
  constructor(private route: ActivatedRoute) {

    this.route.queryParams.subscribe(params => {
      this.reportId = params['id'];
      this.fromvno = params['fromvno'];
      this.tovno = params['tovno'];
      this.noOfCopy = params['noOfCopy'];
      this.source = params['source'];
    });


    //   var ajaxSetup = DXAnalytics.Analytics.Utils.ajaxSetup
    //   ajaxSetup.ajaxSettings = {
    //     xhrFields: {
    //       withCredentials: true
    //    }
    // };
  }
  reportUrl: string;//='NewRpt3####SB-000017';// 'SampleReport';
  //hostUrl: string = 'http://localhost:12345/';
  hostUrl: string;//= 'https://localhost:7016/';
  invokeAction: string;//= 'DXXRDV';

  ngOnInit(): void {

    if (this.reportId > 0 && this.tovno.length >= 1) {
      let CUID = localStorage.getItem('CUID');
      this.reportUrl = this.fromvno + '####' + this.tovno + '####' + this.noOfCopy + '####' + this.reportId + '####' + this.source + "####" + CUID;
      console.log(this.reportUrl);
      this.hostUrl = environment.appUrl;
      this.invokeAction = 'DXXRDV';
      if (this.viewer) {
        this.viewer;
        console.log('this.viewer', this.viewer);
      }
    }
  }
  print() {
    this.viewer.bindingSender.Print(0);

  }

  OnParametersInitialized(evt) {


  }

  CustomizeMenuActions(event) {

    var panelPart = event.args.GetById(PreviewElements.RightPanel);
    var index = event.args.Elements.indexOf(panelPart);
    event.args.Elements.splice(index, 1);

    // Hide the "Print" and "PrintPage" actions. 
    // var printAction = event.args.GetById(ActionId.Print);
    // if (printAction)
    //     printAction.visible = false;
    // var printPageAction = event.args.GetById(ActionId.PrintPage);
    // if (printPageAction)
    //     printPageAction.visible = false;


  }

}